<!--Logo-->
<div>
	<div style="display: grid">
		<h2 *ngIf="ShowDistrictName == true" class="DistrictName">
			{{ DistrictDisplayName }}
		</h2>
		<span class="VersionNumber">{{ DistrictVersionNumber }}</span>
		<i *ngIf="DistrictInfoLoading == true" class="pi-spin pi pi-spinner" style="font-size: 45px; margin-bottom: 15px"></i>
	</div>

	<img alt="image" src="assets/images/CAASS_LOGO_NEW.png" width="190" style="margin-top: 2px" />
	<h3>Welcome to CAASS®</h3>

	<div class="alert alert-danger" *ngIf="errorMessage && VersionMatch == true">
		<p>{{ errorMessage }}</p>
	</div>

	<div class="alert alert-danger" *ngIf="VersionMatch == false && VersionChecked == true">
		<p>
			Your browser has cached Version
			{{ CAASS_VERSION.replace("v", "") }} of CAASS but the server is running {{ DistrictVersionNumber.replace("v", "") }}
		</p>
		<p>
			Please clear your browser cache and refresh the page. For Google Chrome and Microsoft Edge browser press Ctrl+F5. For Apple Safari users, please use
			Command+Shift+R
		</p>
		<p>
			If you are still having issues please
			<a href="https://www.access411.com/online-support/">Contact Support</a>
		</p>
	</div>
</div>
